import { Box, Divider, ListItemButton, Typography } from '@mui/material';
import React, { Component } from 'react';
import { Virtuoso } from 'react-virtuoso';
import LocationListItem from './Elements/LocationListItem';
import { Location, Position } from './Types/Types';

type onClickCallback = (e : React.MouseEvent, loc : Location) => any;

interface Props {
    locations: Location[],
    onClick?: onClickCallback,
    minimalList?: boolean,
}

class LocationList extends Component<Props, {coords: Position}> {
    constructor(props : Props) {
        super(props);

        const coords = localStorage.getItem('coords');
        
        this.state={
            coords: coords ? JSON.parse(coords) : undefined,
        };
    }

    componentDidMount() {
        const _self = this;
        navigator.geolocation.getCurrentPosition(function(position) {
            _self.setState({
                coords: {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                }
            });
        });
    }

    handleOnClick = (e : React.MouseEvent, loc : Location) => {
        const { onClick } = this.props;
        if (typeof onClick === 'function') {
            onClick(e, loc);
        }
    }

    render() {
        const { locations, minimalList = false } = this.props;
        const { coords } = this.state;

        return (
            <React.Fragment>
                {(locations.length > 0)
                    ? <Virtuoso totalCount={200} data={locations} itemContent={(index : number, loc : Location) => {
                        const sameUser = index > 0 && loc.user_id === locations[index-1].user_id;
                        const nextSameUser = index < (locations.length - 1) && loc.user_id === locations[index+1].user_id;

                        return <React.Fragment>
                        <ListItemButton key={"list-item-" + index} onClick={(e) => this.handleOnClick(e, loc)} sx={{ pt: sameUser ? 0 : undefined, pb: nextSameUser ? 0 : undefined }}>
                            <LocationListItem coords={coords} location={loc} minimalList={minimalList} hideAvatar={sameUser}/>
                        </ListItemButton>
                        {((index < (locations.length - 1)) && nextSameUser === false) && <Divider variant={minimalList ? undefined : "inset"} />}
                        </React.Fragment>;
                    }
                    }/>
                    :<Box sx={{ display: 'grid', placeItems: 'center', height: '100%', textAlign: 'center' }}>
                        <Box>
                            <Box><Typography variant={"h6"}>No koa Bier trunkn!</Typography></Box>
                            <Box><Typography variant={"body1"}>I dat moi oas trinkn!</Typography></Box>
                        </Box>
                    </Box>}
            </React.Fragment>
        );
    }
}
export default LocationList;